import { toastError } from '../../utils/toastMessage';
import { setChosenEatings } from '../menu';
import { setChosenTemplateEatings } from '../templateGenerator';
import {
  EATING_TAGS,
  DISH_TYPE_TAGS,
  CATEGORY_INGREDIENTS,
  VIDEO_TAGS,
} from '../../constants/appConstants';
import * as constants from '../../constants/constants';
import API from '../../utils/API';

export const getTagsSuccess = (data) => {
  return {
    type: constants.GET_TAGS_SUCCESS,
    data,
  };
};

export const setTagsByCategories = ({
  allEatingsTags,
  allDishTypeTags,
  allCategoryIngridients,
  allVideoTags,
}) => {
  return {
    type: constants.SET_TAGS_BY_CATEGORIES,
    payload: {
      allEatingsTags,
      allDishTypeTags,
      allCategoryIngridients,
      allVideoTags,
    },
  };
};

export const getTags = () => {
  return (dispatch) => {
    API.get('/tags')
      .then((response) => {
        const { tags } = response.data.data;
        const allEatingsTags = [];
        const allDishTypeTags = [];
        const allCategoryIngridients = [];
        const allVideoTags = [];
        tags.forEach((tag) => {
          if (tag.category_id === EATING_TAGS) allEatingsTags.push(tag);
          if (tag.category_id === DISH_TYPE_TAGS) allDishTypeTags.push(tag);
          if (tag.category_id === CATEGORY_INGREDIENTS) allCategoryIngridients.push(tag);
          if (tag.category_id === VIDEO_TAGS) allVideoTags.push(tag);
        });
        dispatch(
          setTagsByCategories({
            allEatingsTags,
            allDishTypeTags,
            allCategoryIngridients,
            allVideoTags,
          }),
        );

        const allEatingsTagsIds = allEatingsTags.map((tag) => tag.tag_id);
        dispatch(setChosenEatings(allEatingsTagsIds));
        dispatch(setChosenTemplateEatings(allEatingsTagsIds));
        dispatch(getTagsSuccess(tags));
      })
      .catch(() => {
        toastError();
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/tags/getTags.js